export default __webpack_public_path__ + "/dist/images/close-img.e9d85c8b5cab74043b2871230befc666.svg";